import * as z from "zod";

const UserResumeDtoSchema = z
    .object({
        id: z.number(),
        email: z.string().trim(),
    })
    .readonly();

export const SpatialLevelResumeDtoSchema = z.object({
    id: z.number(),
    name: z.string().trim(),
    to_label: z.string().trim(),
    users: z.array(UserResumeDtoSchema),
});

export type SpatialLevelResumeDto = z.output<
    typeof SpatialLevelResumeDtoSchema
>;

export const SpatialLevelsResumeDtoSchema = z
    .array(SpatialLevelResumeDtoSchema)
    .readonly();
export type SpatialLevelsResumeDto = z.output<
    typeof SpatialLevelsResumeDtoSchema
>;

export interface SpatialLevelResumeCreateBody {
    spatial_level_id: number;
}

export interface SpatialLevelResumeAddUserBody {
    spatial_level: {
        user_ids: number[];
    };
}
